import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['income', 'incomeRequireError', 'incomeFormatError', 'submitButton']

  connect() {
    this.controllSubmitButton()
  }

  requireInvalid() {
    return this.incomeTarget.value == ''
  }

  controllRequireError() {
    this.incomeRequireErrorTarget.classList.add('regist_form__hide')

    const isAddressInvalid = this.requireInvalid()

    this.incomeTarget.classList.toggle('regist_form__error_input', isAddressInvalid)
    this.incomeRequireErrorTarget.classList.toggle('regist_form__hide', !isAddressInvalid)
  }

  formatInvalid() {
    if (this.requireInvalid()) { return false }

    const value = this.incomeTarget.value

    return isNaN(value) || value.length >= 5
  }

  controllFormatError() {
    this.incomeFormatErrorTarget.classList.add('regist_form__hide')
    if (this.requireInvalid()) { return }

    const isFormatInvalid = this.formatInvalid()

    this.incomeTarget.classList.toggle('regist_form__error_input', isFormatInvalid)
    this.incomeFormatErrorTarget.classList.toggle('regist_form__hide', !isFormatInvalid)
  }

  controllSubmitButton() {
    const isIncomeValid = this.incomeTarget.value !== '' && !isNaN(this.incomeTarget.value);

    this.submitButtonTarget.disabled = !isIncomeValid;
    this.submitButtonTarget.classList.toggle('regist_form__button--disabled', !isIncomeValid);
  }

  convertToHalfWidth() {
    const inputValue = this.incomeTarget.value;

    // 全角数字を半角数字に変換
    const convertedValue = inputValue.replace(/[０-９－ー-\s　]/g, (match) => {
      if (match === "－" || match === "ー" || match === "-") return "" // ハイフンを削除
      if (match === " " || match === "　") return "" // スペースを削除
      return String.fromCharCode(match.charCodeAt(0) - 0xFEE0)
    });

    // 入力フィールドに変換後の値を設定
    this.incomeTarget.value = convertedValue
  }
}
